// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3p5WJ","additionalInfo":"AgreementModal_additionalInfo__3__Fx"};